/**
 * Youtube用のutilクラス
 */
class YoutubeUtil {
  /**
   * 通常のURLを埋め込み形式URLとして変換する
   * すでに埋め込み形式だった場合か、通常のURL以外の場合、何もせずに返す
   */
  static getEmbedUrl (url) {
    if (!url) return
    let param = null
    let match = url.match(/https:\/\/www\.youtube\.com\/watch\?v=(.+)/)
    if (match && match.length > 1) {
      param = match[1]
    } else {
      match = url.match(/https:\/\/youtu\.be\/(.+)/)
      if (match && match.length > 1) {
        param = match[1]
      }
    }
    return 'https://www.youtube.com/embed/' + param
  }
}

export default YoutubeUtil
